/* istanbul ignore file */
import { useEmployeeUrl, CREATE_EMPLOYEE } from 'domain/shared/employee';
import { CreateButton } from 'framework/ui/ui-builder';

const CreateEmployeeButton = () => {
  const { getCreateUrl } = useEmployeeUrl();

  return (
    <CreateButton
      url={getCreateUrl()}
      label="Create worker"
      key="create-employee"
      permissionToCheck={CREATE_EMPLOYEE}
    />
  );
};

export default CreateEmployeeButton;
